import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "pv_session";

/**
 * Lightweight, GDPR-compliant page view tracker.
 * No cookies, no PII — stores only anonymous aggregate counters.
 */
export function usePageViewTracker() {
  const location = useLocation();
  const prevPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    if (path === prevPath.current) return;
    prevPath.current = path;

    // Determine if this is a new session (first page view)
    let isNewSession = false;
    try {
      if (!sessionStorage.getItem(SESSION_KEY)) {
        sessionStorage.setItem(SESSION_KEY, "1");
        isNewSession = true;
      }
    } catch {
      // sessionStorage unavailable (private mode) — count as new
      isNewSession = true;
    }

    // Fire-and-forget — never block UX
    supabase.functions
      .invoke("track-pageview", {
        body: { path, is_new_session: isNewSession },
      })
      .catch(() => {});

    // Only count as new session on the very first page of the visit
    // Subsequent navigations in the same session are just view increments
  }, [location.pathname]);
}
